import { Directive, Renderer2, ElementRef, Input, OnInit, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appSliderLimits]'
})
export class SliderLimitsDirective implements OnInit, OnChanges {
  @Input() macro: string;

  _diet: string;
  get diet(): string {
    return this._diet;
  }

  @Input()
  set diet(value:string){
    this._diet = value;
    this.renderLimits();
  }

  @Input() map: any;
  @Input() path: string;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  lowDiv:any;
  highDiv:any;
  trackParent:any;
  thumbLabel:any;
  thumbLabelText:any;
  thumbLabelTextWrapper:any;
  lowStopDiv:any;
  highStopDiv:any;
  track:any;

  ngOnInit() {
    this.renderLimits();
  }

  renderLimits() {
    if (this.map && this.path && this.diet && this.macro) {
      this.trackParent = this.el.nativeElement.getElementsByClassName('mat-slider-track-wrapper')[0];

      let lowLimitPercentage = (this.map[this.diet][this.macro].limits[this.path].low) / 100;
      let highLimitPercentage = (this.map[this.diet][this.macro].limits[this.path].high) / 100;

      if (!this.lowDiv) {

        this.lowDiv = this.renderer.createElement('div');
        this.renderer.addClass(this.lowDiv,'mat-slider-track-fill');
        this.renderer.addClass(this.lowDiv,'mat-calc-low-limit');
        this.renderer.appendChild(this.trackParent, this.lowDiv);
      }

      if (!this.lowStopDiv) {
        if (lowLimitPercentage >= .01) {
          this.lowStopDiv = this.renderer.createElement('div');
          this.renderer.addClass( this.lowStopDiv, 'slider-stop' );
          this.renderer.appendChild( this.trackParent, this.lowStopDiv );
        }
      }

      if (this.lowStopDiv) {
        this.renderer.setAttribute(this.lowStopDiv, 'style', `left:${100 * lowLimitPercentage}%;`);
      }

      this.renderer.setAttribute(this.lowDiv, 'style', `transform: translateX(0px) scale3d(${lowLimitPercentage}, 1, 1); background:#555;`);

      if (!this.highDiv) {
        this.highDiv = this.renderer.createElement('div');
        this.renderer.addClass(this.highDiv,'mat-slider-track-fill');
        this.renderer.addClass(this.highDiv,'mat-calc-high-limit');
        this.renderer.appendChild(this.trackParent, this.highDiv);
      }

      if (!this.highStopDiv) {
        if (highLimitPercentage >= .01) {
          this.highStopDiv = this.renderer.createElement('div');
          this.renderer.addClass( this.highStopDiv, 'slider-stop' );
          this.renderer.appendChild( this.trackParent, this.highStopDiv );
        }
      }

      if (this.highStopDiv) {
        this.renderer.setAttribute(this.highStopDiv, 'style', `left:${(100 * highLimitPercentage)}%;`);
      }

      this.renderer.setAttribute(this.highDiv, 'style', `transform: translateX(${(100*
        highLimitPercentage)}%) scale3d(${1 - highLimitPercentage}, 1, 1); background:#555;`);

      if (!this.thumbLabelTextWrapper ) {
        this.thumbLabel = this.el.nativeElement.getElementsByClassName('mat-slider-thumb-label')[0];
        this.thumbLabelText = this.el.nativeElement.getElementsByClassName('mat-slider-thumb-label-text')[0];
        this.thumbLabelTextWrapper = this.renderer.createElement('div');
        this.renderer.addClass( this.thumbLabelTextWrapper, 'mat-slider-thumb-label-text-wrapper');
        this.renderer.appendChild( this.thumbLabel, this.thumbLabelTextWrapper );
        this.renderer.appendChild( this.thumbLabelTextWrapper, this.thumbLabelText );

        this.renderer.addClass( this.thumbLabel, this.macro );
      }

      this.track = this.el.nativeElement.getElementsByClassName('mat-slider-track-fill')[0];
      this.renderer.addClass( this.track, this.macro );
    }    
  }

  ngOnChanges = (changes: SimpleChanges) => {
    this.renderLimits();
  }

}
